import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import I18n from 'i18n-react';
import { CPF as CpfValidator, CNPJ as CnpjValidator } from 'cpf_cnpj';

const propTypes = {
  id: PropTypes.string.isRequired,
  changeValue: PropTypes.func.isRequired,
  required: PropTypes.bool,
  errorMessage: PropTypes.string,
  invalidValueErrorMessage: PropTypes.string
};

const defaultProps = {
  required: false,
  errorMessage: '',
  invalidValueErrorMessage: ''
};

class CardCnpjCpf extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isValidState: true,
      value: ''
    };
  }

  renderLabel() {
    return (
      <Row className="Field__label">
        <Col id={`${this.props.id}_cardCnpjCpfLabel`} xs={12}>
          <span className={this.state.isValidState ? 'Field__validField' : 'Field__invalidField'}>
            {I18n.translate('components.checkoutInfo.cardCnpjCpf.label')}
          </span>
          {this.props.required ? (
            <span id="requiredIconId" className="Field__required">
              {' '}
              •
            </span>
          ) : (
            ''
          )}
        </Col>
      </Row>
    );
  }

  renderField() {
    return (
      <Row>
        <Col xs={12}>         
          <input
            type="tel"
            id={`${this.props.id}_cardCnpjCpfId`}
            onChange={event => this.removeInvalidCharacters(event.target.value)}
            onBlur={event => {this.validateField(event.target.value);this.onBlurFieldToIco(event)}}
            placeholder={I18n.translate('components.checkoutInfo.cardCnpjCpf.placeholder')}
            className={`Field__input ${
              this.state.isValidState ? 'Field__validInput' : 'Field__invalidInput'
            }`}
            value={this.state.value}
            maxLength={18}
            ref={ref => (this.input = ref)}
            style={this.props.styleEncode}
          />
        </Col>
      </Row>
    );
  }  

  onBlurFieldToIco(event){
    if(this.props.styleFieldIdentifier &&  this.props.callCenterMode)  
     return this.props.onBlurFieldToIco(this.props.styleFieldIdentifier,this.props.iconIdentifier,event)
   }

  renderValidationMessage() {
    let message = <Row id={`${this.props.id}__cardCnpjCpfFooter`} className="Field__message" />;

    if (!this.state.isValidState) {
      message = (
        <Row className="Field__message error">
          <Col id={`${this.props.id}__cardCnpjCpfFooter`} xs={12}>
            <span className="Field__invalidField">{I18n.translate(this.state.errorMessage)}</span>
          </Col>
        </Row>
      );
    }

    return message;
  }

  validate = () => {
    return this.validateField(this.state.value);
  };

  validateField = value => {
    if (CpfValidator.isValid(value)) {
      this.setState({
        value: CpfValidator.format(String(value)),
        isValidState: true
      });
    } else if (CnpjValidator.isValid(value)) {
      this.setState({
        value: CnpjValidator.format(String(value)),
        isValidState: true
      });
    } else {
      const isFieldRequired = this.props.required && value.length <= 0;
      const errorMessage = isFieldRequired
        ? this.props.errorMessage
        : this.props.invalidValueErrorMessage;

      this.setState({
        isValidState: false,
        errorMessage: errorMessage
      });
    }

    this.props.changeValue(value);

    return this.state.isValidState;
  };

  removeInvalidCharacters = value => {
    this.setState({
      value: value.replace(/[^0-9./-]+/, '')
    });
  };

  render() {
    return (
      <div id={this.props.id} className="TextField Field">
        {this.renderLabel()}
        {this.renderField()}
        {this.renderValidationMessage()}
      </div>
    );
  }
}

CardCnpjCpf.propTypes = propTypes;
CardCnpjCpf.defaultProps = defaultProps;

export default CardCnpjCpf;



// WEBPACK FOOTER //
// ./src/components/checkoutInfo/cardCnpjCpf/CardCnpjCpf.jsx